<template>
  <footer class="bg-gray-900 text-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid md:grid-cols-2 gap-8">
        <!-- Company Info -->
        <div class="space-y-4">
          <div class="flex items-center space-x-2">
            <img
              src="/greyed-logo.png"
              alt="GreyED Logo"
              class="w-8 h-8 object-contain"
            />
            <span class="text-xl font-bold">GreyED</span>
          </div>
          <p class="text-gray-300 text-sm leading-relaxed">
            Empowering businesses through innovative technology solutions<br />
            and digital transformation.
          </p>
          <div class="flex items-center flex-wrap gap-4 text-sm text-gray-300">
            <RouterLink
              v-if="showContactLink"
              to="/contact"
              class="hover:text-white transition-colors underline"
            >
              Contact Us
            </RouterLink>
            <a
              href="https://www.linkedin.com/in/juliegreyed/"
              class="text-gray-400 hover:text-white transition-colors"
            >
              <Linkedin class="w-5 h-5" />
            </a>
            <div class="flex items-center space-x-2">
              <MapPin class="w-4 h-4" />
              <span>Minnetonka, MN</span>
            </div>
          </div>
        </div>

        <!-- Company -->
        <div class="space-y-4">
          <h3 class="text-lg font-semibold">Company</h3>
          <div class="grid grid-cols-2 gap-x-8 gap-y-2 text-sm">
            <ul class="space-y-2">
              <li>
                <RouterLink
                  to="/about"
                  class="text-gray-300 hover:text-white transition-colors"
                  >About</RouterLink
                >
              </li>
              <li v-if="showContactLink">
                <RouterLink
                  to="/contact"
                  class="text-gray-300 hover:text-white transition-colors"
                  >Contact</RouterLink
                >
              </li>
              <li>
                <RouterLink
                  to="/honors-and-awards"
                  class="text-gray-300 hover:text-white transition-colors"
                  >Honors and Awards</RouterLink
                >
              </li>
            </ul>
            <ul class="space-y-2">
              <li>
                <RouterLink
                  to="/services"
                  class="text-gray-300 hover:text-white transition-colors"
                  >Services</RouterLink
                >
              </li>
              <li v-if="showTestimonialsLink">
                <RouterLink
                  to="/testimonies"
                  class="text-gray-300 hover:text-white transition-colors"
                  >Testimonies</RouterLink
                >
              </li>
              <li>
                <RouterLink
                  to="/why-work-with-us"
                  class="text-gray-300 hover:text-white transition-colors"
                  >Why Work With Us</RouterLink
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="mt-12 pt-8 border-t border-gray-800">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <p class="text-gray-400 text-sm">
            © 2025 GreyED Solutions. All rights reserved.
          </p>
          <div class="mt-4 md:mt-0 flex space-x-6 text-sm">
            <RouterLink
              to="/privacy"
              class="text-gray-400 hover:text-white transition-colors"
            >
              Privacy Policy
            </RouterLink>
            <RouterLink
              v-if="showTermsLink"
              to="/terms"
              class="text-gray-400 hover:text-white transition-colors"
            >
              Terms of Service
            </RouterLink>
            <RouterLink
              to="/cookies"
              class="text-gray-400 hover:text-white transition-colors"
            >
              Cookie Policy
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { Linkedin, MapPin } from "lucide-vue-next";
import { useFeatureFlag } from "@/lib/featureFlags";

const showContactLink = useFeatureFlag("contactForm");
const showTestimonialsLink = useFeatureFlag("testimonials");
const showTermsLink = useFeatureFlag("termsOfService");
</script>
